export function trimLongText(text, length = 10) {
  if (!text) return "undefined";
  return text.length > length ? text.slice(0, length) + "..." : text;
}
